export /**
 * Returns a basic edge detection kernel.
 * @returns {Array<number[]>} asd
 */
  const EdgeDetection = () => [
    [-1, -1, -1],
    [-1, 8, -1],
    [-1, -1, -1],
  ];
